module.exports = __webpack_public_path__ + "img/35.a397c539.png";